export default {
      id: "ic_newsletter-usage",
      viewBox: "0 0 60 60",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic_newsletter-usage",
      toString: function () {
        return this.url;
      }
    }